import { useMemo } from 'preact/hooks'
import { useSearchspringContext } from '../fetchers/provider'
import { ResultsCard } from './ResultCard'

export function QuickSearchResults({ parentResults }) {
  const { results } = useSearchspringContext()

  const products = useMemo(() => {
    if (parentResults) {
      return parentResults?.results
    }
    return results?.results
  }, [parentResults, results])

  if (products?.length === 0) return null

  return (
    <div className="grid w-full grid-cols-2 gap-2 overflow-x-scroll shrink-0 md:grid-cols-4">
      {products?.map((result, index) => (
        <ResultsCard
          key={result.handle}
          wishlist={{ type: 'none' }}
          result={result}
          index={index}
          className="shrink-0 basis-1/2 md:shrink md:basis-1/4"
        />
      ))}
    </div>
  )
}
